import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, Selection, IColumn, SelectionMode, Panel, Label, TextField, PanelType, IGroup, IDetailsHeaderProps, DetailsHeader, ShimmeredDetailsList, Spinner, SpinnerSize, Pivot, PivotItem, CheckboxVisibility, Link, Slider, Toggle, TagItemSuggestionBase } from '@fluentui/react';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { DataService } from "../Services/DataService";
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { ILaboGids } from '../Interfaces/ILaboGids';
import { withRouter } from "react-router-dom";

import _ from 'lodash';
require('isomorphic-fetch');
export interface IDisplayLaboState {
    items: ILaboGids[];
    itemsService: ILaboGids[];
    selectionDetails: string;
    selectedItem?: ILaboGids;
    showPanel: boolean;
    groups: IGroup[];
    loading: boolean;
    toggleBuitenNomenclatuur?: boolean;
}

export class DisplayLabo extends React.Component<any, IDisplayLaboState> {
    private _columns: IColumn[];
    private _selection: Selection;

    constructor(props: any) {
        super(props);

        initializeIcons(/* optional base url */);
        this._selection = new Selection({
            onSelectionChanged: () => this.setState({ selectionDetails: this._getSelectionDetails() }),
        });

        this._getLaboGidsData();
        this.state = {
            items: [{ Id: "0", Title: "", Categorie: "", Synoniemen: "" }],
            itemsService: [],
            selectionDetails: this._getSelectionDetails(),
            showPanel: false,
            groups: [],
            loading: true,
            toggleBuitenNomenclatuur: window.location.href.toLocaleLowerCase().lastIndexOf('buitennomenclatuur') > 0
        };




        this._columns = [
            { key: 'Title', name: 'Title', fieldName: 'Title', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'Categorie', name: 'Subdiscipline', fieldName: 'Categorie', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'Staaltype1', name: 'Staaltype', fieldName: 'Staaltype1', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'Recipi_x00eb_nt', name: 'Recipiënt', fieldName: 'Recipi_x00eb_nt', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'Uitvoerfrekwentie', name: 'Uitvoerfrekwentie', fieldName: 'Uitvoerfrekwentie', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'Mnemonic', name: 'Mnemonic', fieldName: 'Mnemonic', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'Aanvraagnr_x002e_', name: 'Aanvraagnr.', fieldName: 'Aanvraagnr_x002e_', minWidth: 100, maxWidth: 200, isResizable: true },
        ];
    }
    private _CreateGroups(data: ILaboGids[]): IGroup[] {

        var groups: IGroup[] = [];
        var index: number = 0;
        data.map((item: ILaboGids) => {

            var char = item.Title.substr(0, 1).toUpperCase();

            if (this._IsNumber(char) && groups.filter(x => x.name == "0").length <= 0) {
                var count = data.filter(x => this._IsNumber(x.Title.substring(0, 1))).length;
                groups.push({ key: "0", startIndex: index, name: "0", count: count, isCollapsed: true });
            } else if (!this._IsNumber(char)) {
                var isNotCreated = groups.filter(x => x.name.toUpperCase() == char).length <= 0;
                if (isNotCreated) {
                    var count = data.filter(x => x.Title.indexOf(char) == 0).length;
                    groups.push({ key: char, startIndex: index, name: char, count: count, isCollapsed: true });
                }
            }
            index++;
        });

        return groups;
    }

    private slugify(text: string) {
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
}

    async _getLaboGidsData() {
    console.log("_getLaboGidsData");

    var dataOrg = await DataService.getLaboGidsData();
    var data = this.state.toggleBuitenNomenclatuur
        ? dataOrg.filter(x => x.IsBuitenRIZIV == true)
        : dataOrg;

    var groups = this._CreateGroups(data);

    const titleSlug = this.props.match?.params?.title;

    if (titleSlug) {
        const match = dataOrg.find((x: ILaboGids) =>
            this.slugify(x.Title) === titleSlug.toLowerCase()
        );

        if (match) {
            const item = await DataService.getLaboGidsItemById(match.Id);

            this.setState({
                items: data,
                itemsService: dataOrg,
                loading: false,
                groups: groups,
                selectedItem: item,
                showPanel: false
            });

            return;
        }
    }

    this.setState({
        items: data,
        itemsService: dataOrg,
        loading: false,
        groups: groups
    });
}
    public render(): JSX.Element {

        const titleSlug = this.props.match?.params?.title;

if (titleSlug && !this.state.selectedItem) {
    return <div>Loading...</div>;
}

        if (this.props.fullScreen && this.state.selectedItem) {
    return (
        <div>
            <h1>{this.state.selectedItem.Title}</h1>

            <Pivot aria-label="Labogids details">
                <PivotItem headerText="Algemene info">
                    {this._fieldRender(this.state.selectedItem, "Categorie", "Subdiscipline")}
                    {this._fieldRender(this.state.selectedItem, "Aanvraagformulier", "Aanvraagformulier°")}
                    {this._fieldRender(this.state.selectedItem, "Uitvoerfrekwentie", "Uitvoerfrekwentie")}
                    {this._fieldRender(this.state.selectedItem, "Urgentie", "Urgentie")}
                    {this._fieldRender(this.state.selectedItem, "Antwoordtijd", "Antwoordtijd")}
                    {this._fieldRender(this.state.selectedItem, "Staaltype1", "Staaltype°")}
                    {this._fieldRender(this.state.selectedItem, "Recipi_x00eb_nt", "Recipiënt°")}
                    {this._fieldRender(this.state.selectedItem, "Volume_x0020_min_x002e__x0020_af", "Volume min. afname°")}
                    {this._fieldRender(this.state.selectedItem, "Afname_x0020_instructies", "Afname instructies°")}
                    {this._fieldRender(this.state.selectedItem, "Transport_x0020__x0028_externe_x", "Transport (ext. stalen)°")}
                    {this._fieldRender(this.state.selectedItem, "Eenheid", "Eenheid")}
                    {this._fieldRender(this.state.selectedItem, "Referentiewaarden", "Referentiewaarden")}
                    {this._fieldRender(this.state.selectedItem, "Klinische_x0020_achtergrond", "Klinische achtergrond°")}
                    {this._fieldRender(this.state.selectedItem, "Modified", "Gewijzigd op")}
                    {this._fieldRender(this.state.selectedItem, "Version", "Versie")}
                </PivotItem>

                <PivotItem headerText="Extra info">
                    {this._fieldRender(this.state.selectedItem, "Mnemonic", "Mnemonic")}
                    {this._fieldRender(this.state.selectedItem, "Aanvraagnr_x002e_", "Aanvraagnr°")}
                    {this._fieldRender(this.state.selectedItem, "Bewaring", "Kamertemperatuur")}
                    {this._fieldRender(this.state.selectedItem, "Werkpost1", "Werkpost")}
                    {this._fieldRender(this.state.selectedItem, "Toestel", "Toestel")}
                    {this._fieldRender(this.state.selectedItem, "Referenties", "Referenties")}
                    {this._fieldRender(this.state.selectedItem, "C_x004f_pm1", "Opmerkingen")}
                      {this.state.selectedItem?.Bijlagen != null ? <Label>Bijlagen:</Label> : null}
                            {this.state.selectedItem?.Bijlagen?.split(';').map((bijlage: string) => {
                                if (bijlage != "") {
                                    var filename = bijlage.substring(bijlage.lastIndexOf('/') + 1);
                                    return (<div>
                                        <Link 
                                        style={{ fontSize: "16px" }}
                                        onClick={() => {
                                            fetch(bijlage)
                                                .then(r => r.blob())
                                                .then((blob) => this.showFile(blob, filename))
                                        }}
                                        >{filename} </Link>
                                    </div>
                                    );
                                }
                            })}
                </PivotItem>

                <PivotItem headerText="Verrekening">
                    {this._fieldRender(this.state.selectedItem, "Aanrekening", "Aanrekening")}
                    {this._fieldRender(this.state.selectedItem, "niet_x0020_RIZIV", "niet RIZIV")}
                </PivotItem>
            </Pivot>
        </div>
    );
}

        return (
            <div>
                <div className="wrapper">
                    <div className="Title">
                        <h1>Labo gids</h1>
                    </div>
                    <div className="ToggleNomenclatuur">
                        <Toggle
                            label='Testen zonder terugbetaling'
                            onChange={(event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                var itemsFiltered = checked ? this.state.itemsService.filter(x => x.IsBuitenRIZIV == true) : this.state.itemsService;
                                // this.setState({ toggleBuitenNomenclatuur: checked, items: itemsFiltered });


                                var groups = this._CreateGroups(itemsFiltered);
                                this.setState({ ...this.state, items: itemsFiltered, loading: false, groups: groups, toggleBuitenNomenclatuur: checked, });

                            }}
                            onText="Aan" offText="Uit"
                            checked={this.state.toggleBuitenNomenclatuur}
                        />
                    </div>
                </div>
                <TextField
                    label="Filter by name:"
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {

                        if (newValue != null) {
                            var lowerValue = newValue.toLowerCase();
                            var filteredItems = this.state.itemsService.filter((i: ILaboGids) =>
                                (i.Title ? i.Title : '').toLowerCase().indexOf(lowerValue) > -1
                                || (i.Synoniemen ? i.Synoniemen : '').toLowerCase().indexOf(lowerValue) > -1
                                || (i.Mnemonic ? i.Mnemonic : '').toLowerCase().indexOf(lowerValue) > -1
                                || (i.Aanrekening ? i.Aanrekening : '').toLowerCase().indexOf(lowerValue) > -1                                
                                || (i.Klinische_x0020_achtergrond ? i.Klinische_x0020_achtergrond : '').toLowerCase().indexOf(lowerValue) > -1);
                                filteredItems = this.state.toggleBuitenNomenclatuur ?filteredItems.filter(x => x.IsBuitenRIZIV == true) : filteredItems;
                            var groups = this._CreateGroups(filteredItems);
                            this.setState({ items: filteredItems, groups: groups });
                        } else {
                            var data = this.state.toggleBuitenNomenclatuur ? this.state.itemsService.filter(x => x.IsBuitenRIZIV == true) : this.state.itemsService;
                            var groups = this._CreateGroups(data);
                            this.setState({ items: data, groups: groups });
                        }

                    }}
                />

                <DetailsList
                    items={this.state.items}
                    columns={this._columns}
                    layoutMode={DetailsListLayoutMode.justified}
                    selection={this._selection}
                    checkboxVisibility={CheckboxVisibility.hidden}
                    selectionPreservedOnEmptyClick={true}
                    selectionMode={SelectionMode.single}
                    groups={this.state.groups}
                    compact={true}
                />
                {this.state.loading ? <Spinner size={SpinnerSize.large} /> : null}
                <Panel
                    headerText={this.state.selectedItem != null ? this.state.selectedItem.Title : "null"}
                    isOpen={this.state.showPanel}
                    onDismiss={() => {
                        this.setState({ showPanel: false });
                        this._selection.setAllSelected(false);
                    }
                    }
                    isLightDismiss
                    type={PanelType.large}
                    closeButtonAriaLabel="Close"
                >


                    <Pivot aria-label="Basic Pivot Example">
                        {this.state.toggleBuitenNomenclatuur ?
                            <PivotItem headerText="Verrekening">
                                {this._fieldRender(this.state.selectedItem, "Aanrekening", "Aanrekening")}
                                {this._fieldRender(this.state.selectedItem, "niet_x0020_RIZIV", "niet RIZIV")}
                            </PivotItem> : null}
                        <PivotItem headerText="Algemene info">
                            {this._fieldRender(this.state.selectedItem, "Categorie", "Subdiscipline")}
                            {this._fieldRender(this.state.selectedItem, "Aanvraagformulier", "Aanvraagformulier°")}
                            {this._fieldRender(this.state.selectedItem, "Uitvoerfrekwentie", "Uitvoerfrekwentie")}
                            {this._fieldRender(this.state.selectedItem, "Urgentie", "Urgentie")}
                            {this._fieldRender(this.state.selectedItem, "Antwoordtijd", "Antwoordtijd")}
                            {this._fieldRender(this.state.selectedItem, "Staaltype1", "Staaltype°")}
                            {this._fieldRender(this.state.selectedItem, "Recipi_x00eb_nt", "Recipiënt°")}
                            {this._fieldRender(this.state.selectedItem, "Volume_x0020_min_x002e__x0020_af", "Volume min. afname°")}
                            {this._fieldRender(this.state.selectedItem, "Afname_x0020_instructies", "Afname instructies°")}
                            {this._fieldRender(this.state.selectedItem, "Rejectiecriteria", "Rejectiecriteria°")}
                            {this._fieldRender(this.state.selectedItem, "Transport_x0020__x0028_externe_x", "Transport (ext. stalen)°")}
                            {this._fieldRender(this.state.selectedItem, "Transporttijd", "Transporttijd°")}
                            {this._fieldRender(this.state.selectedItem, "Meetmethode", "Meetmethode")}
                            {this._fieldRender(this.state.selectedItem, "Eenheid", "Eenheid")}
                            {this._fieldRender(this.state.selectedItem, "Referentiewaarden", "Referentiewaarden")}
                            {this._fieldRender(this.state.selectedItem, "Referentiewaarden_x0020_Extra", "Referentiewaarden Extra")}
                            {this._fieldRender(this.state.selectedItem, "Rapportering_x002f_Interpretatie", "Rapportering/Interpretatie")}
                            {this._fieldRender(this.state.selectedItem, "Interferentie", "Interferentie")}
                            {this._fieldRender(this.state.selectedItem, "Klinische_x0020_achtergrond", "Klinische achtergrond°")}
                            {this._fieldRender(this.state.selectedItem, "Verantwoordelijke_x0020_KB_x00200", "Verantw. KB medisch")}
                            {this._fieldRender(this.state.selectedItem, "Accreditatie", "Accreditatie Belac MED 405")}
                            {this._fieldRender(this.state.selectedItem, "Lab", "Lab")}
                            {/* {this._fieldRender(this.state.selectedItem, "Link", "Link", true)} */}
                            {this._fieldRender(this.state.selectedItem, "Synoniemen", "Synoniemen")}
                            {/* {this.state.toggleBuitenNomenclatuur ? null : this._fieldRender(this.state.selectedItem, "niet_x0020_RIZIV", "niet RIZIV")} */}
                            {this._fieldRender(this.state.selectedItem, "Modified", "Gewijzigd op")}
                            {this._fieldRender(this.state.selectedItem, "Version", "Versie")}

                             {this.state.selectedItem && (
    <div style={{ marginTop: 20 }}>
        <Link
            onClick={() => {
                const url = `${window.location.origin}/#/Labogids/${this.slugify(this.state.selectedItem!.Title)}`;
                navigator.clipboard.writeText(url);
                
            }}
        >
            Copy link to item
        </Link>
    </div>
)}
                        </PivotItem>
                        <PivotItem headerText="Extra info">
                            {this._fieldRender(this.state.selectedItem, "Mnemonic", "Mnemonic")}
                            {this._fieldRender(this.state.selectedItem, "Aanvraagnr_x002e_", "Aanvraagnr°")}
                            {this._fieldRender(this.state.selectedItem, "Bewaring", "Kamertemperatuur")}
                            {this._fieldRender(this.state.selectedItem, "Bewaren_x0020_4_x00b0_C", "2-8°C")}
                            {this._fieldRender(this.state.selectedItem, "C_x002d_20_x00b0_C", "-20°C")}
                            {this._fieldRender(this.state.selectedItem, "C_x002d_70_x00b0_C", "-80°C")}
                            {this._fieldRender(this.state.selectedItem, "Werkpost1", "Werkpost")}
                            {this._fieldRender(this.state.selectedItem, "Verantwoordelijke_x0020_KB_x0020", "Verantw. KB technisch")}
                            {this._fieldRender(this.state.selectedItem, "Toestel", "Toestel")}
                            {this._fieldRender(this.state.selectedItem, "Volume_x0020_min_x002e_", "Volume min. test")}
                            {this._fieldRender(this.state.selectedItem, "Staaltype_x0020_gevalideerd", "Staaltype ook gevalideerd")}
                            {this._fieldRender(this.state.selectedItem, "Rerun_x0020_ondergrens", "Rerun ondergrens")}
                            {this._fieldRender(this.state.selectedItem, "Rerun_x0020_bovengrens", "Rerun bovengrens")}
                            {this._fieldRender(this.state.selectedItem, "Meetbereik", "Meetbereik")}
                            {this._fieldRender(this.state.selectedItem, "Detectielimiet", "Detectielimiet")}
                            {this._fieldRender(this.state.selectedItem, "Verdunning", "Verdunning")}
                            {this._fieldRender(this.state.selectedItem, "Meetonzekerheid", "Meetonzekerheid")}
                            {this._fieldRender(this.state.selectedItem, "Doorbelwaarde_x0020_ondergrens", "Doorbelwaarde ondergrens")}
                            {this._fieldRender(this.state.selectedItem, "Doorbelwaarde", "Doorbelwaarde bovengrens")}
                            {this._fieldRender(this.state.selectedItem, "Doorbelwaarden", "Doorbelwaarden")}
                            {this._fieldRender(this.state.selectedItem, "Technische_x0020_achtergrond", "Technische achtergrond")}
                            {this._fieldRender(this.state.selectedItem, "Hookeffect", "Hookeffect")}
                            {this._fieldRender(this.state.selectedItem, "Sensitiviteit_x0020_functioneel", "Sensitiviteit functioneel")}
                            {this._fieldRender(this.state.selectedItem, "Variabiliteit_x0020_analytisch", "Variabiliteit analytisch")}
                            {this._fieldRender(this.state.selectedItem, "Variabiliteit_x0020_biologisch", "Variabiliteit biologisch")}
                            {this._fieldRender(this.state.selectedItem, "EQC", "EQC")}
                            {this._fieldRender(this.state.selectedItem, "IQC", "IQC")}
                            {this._fieldRender(this.state.selectedItem, "IQC_x0020_frekwentie", "IQC frekwentie")}
                            {this._fieldRender(this.state.selectedItem, "IQC_x0020_software", "IQC software")}
                            {/* {this.state.toggleBuitenNomenclatuur ? null : this._fieldRender(this.state.selectedItem, "Aanrekening", "Aanrekening")} */}
                            {this._fieldRender(this.state.selectedItem, "RIZIV", "RIZIV")}
                            {this._fieldRender(this.state.selectedItem, "Registratie_x0028_s_x0029_", "Registratie(s)")}
                            {this._fieldRender(this.state.selectedItem, "Referenties", "Referenties")}
                            {this._fieldRender(this.state.selectedItem, "C_x004f_pm1", "Opmerkingen")}
                            {this.state.selectedItem?.Bijlagen != null ? <Label>Bijlagen:</Label> : null}
                            {this.state.selectedItem?.Bijlagen?.split(';').map((bijlage: string) => {
                                if (bijlage != "") {
                                    var filename = bijlage.substring(bijlage.lastIndexOf('/') + 1);
                                    return (<div>
                                        <Link onClick={() => {
                                            fetch(bijlage)
                                                .then(r => r.blob())
                                                .then((blob) => this.showFile(blob, filename))
                                        }}
                                        >{filename} </Link>
                                    </div>
                                    );
                                }
                            })}
                        </PivotItem>

                        {!this.state.toggleBuitenNomenclatuur ?
                        <PivotItem headerText="Verrekening">
                            {this._fieldRender(this.state.selectedItem, "Aanrekening", "Aanrekening")}
                            {this._fieldRender(this.state.selectedItem, "niet_x0020_RIZIV", "niet RIZIV")}
                        </PivotItem> : null}
                    </Pivot>

                   



                </Panel>
            </div >

        );
    }
    private showFile(blob: any, filename: string) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([blob], { type: "application/pdf" })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob

        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //     window.navigator.msSaveOrOpenBlob(newBlob);
        //     return;
        // }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    private _fieldRender(item: any, fieldName: string, displayName: string, link: boolean = false) {
        if (item != null && item[fieldName] != null && item[fieldName] != undefined && item[fieldName] != "" && item[fieldName] != "<div>&#160;</div>" && item[fieldName] != "<div></div>") {
            var content = item[fieldName];
            return (
                <div>
                    <Label>{displayName}</Label>
                    {link ?
                        <Link href={content.split(';')[1]}>{content.split(';')[0]}</Link> :

                        <div className={"content"} dangerouslySetInnerHTML={{ __html: content != null ? content != null && content != "" ? content : "Geen" : "Geen" }} />}

                </div>
            )
        }
        else
            return null;
    }

    private _IsNumber(char: string) {
        switch (char) {
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return true;
            default: return false;

        }
    }
    private async _setSelectedItem(selectionItem: ILaboGids) {
        var item = await DataService.getLaboGidsItemById(selectionItem.Id);
        this.setState({ showPanel: true, selectedItem: item });
    }
    private _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();
        switch (selectionCount) {
            case 0:
                this.setState({ showPanel: false, selectedItem: undefined });
                return "";
            case 1:
                this._setSelectedItem(this._selection.getSelection()[0] as any)
                return "";
            default:
                this.setState({ showPanel: false, selectedItem: undefined });
                return "";
        }
    }



}

export default withRouter(DisplayLabo);
